import { Widget } from '@typeform/embed-react';
import { FC } from 'react';

import styles from './FeedbackWidget.module.scss';

interface FeedbackWidgetProps {
  feedbackQuestionsId?: string;
  serviceAppointmentId?: string;
}

const FeedbackWidget: FC<FeedbackWidgetProps> = ({ feedbackQuestionsId, serviceAppointmentId }) => {
  if (!feedbackQuestionsId || !serviceAppointmentId) {
    return null;
  }

  return (
    <Widget
      className={styles.widget}
      hidden={{
        service_appointment_id: serviceAppointmentId
      }}
      id={feedbackQuestionsId}
      inlineOnMobile
      typeform-welcome={0}
    />
  );
};

export default FeedbackWidget;
